import { inject } from 'tsyringe'
import { Store } from 'vuex'
import { containerScoped } from '~/decorators/dependency-container'
import CookiesService from '~/services/CookiesService'
import { RootState } from '~/store/types'
import { DARK_THEME_ENABLED_COOKIE_NAME, Theme } from '~/constants/theme/theme'
import { THEME_NS } from '~/store/modules/shared/theme/state'
import { SET_ACTIVE_THEME } from '~/store/modules/shared/theme/mutation-types'

@containerScoped()
export default class ThemeService {
  constructor(
    @inject(Store) private store: Store<RootState>,
    @inject(CookiesService) private cookies: CookiesService
  ) {}

  enableDarkTheme(): void {
    this.cookies.set(DARK_THEME_ENABLED_COOKIE_NAME, '1')
    this.store.commit(`${THEME_NS}/${SET_ACTIVE_THEME}`, Theme.DARK)
  }

  enableLightTheme(): void {
    this.cookies.delete(DARK_THEME_ENABLED_COOKIE_NAME)
    this.store.commit(`${THEME_NS}/${SET_ACTIVE_THEME}`, Theme.LIGHT)
  }

  toggleTheme(): void {
    const themeIsLight = this.store.getters[`${THEME_NS}/themeIsLight`]
    if (themeIsLight) {
      this.enableDarkTheme()
    } else {
      this.enableLightTheme()
    }
  }

  themeSwitchIsAvailable(): boolean {
    return false
    // const userIsAdmin = this.store.getters[`${USER_NS}/isAdmin`]
    // return userIsAdmin
  }
}
